import {createApi} from '@reduxjs/toolkit/query/react';
import {axiosBaseQuery} from './api-utils';
import {ContractDetailsRequest} from '../@types/ContractInfoTypes';

const URL_API = '/business_webctrinfo/rest/v1';

export const contractInfoApi = createApi({
    reducerPath: 'contractInfoApi',
    baseQuery: axiosBaseQuery({
        baseUrl: URL_API
    }),
    endpoints: (builder) => ({
        details: builder.query<any, ContractDetailsRequest>({
            query: (request) => ({
                url: '/synthesis/details/' + request.urlEnd,
                method: 'POST',
                data: request.data
            })
        })
    })
});

export const {
    useDetailsQuery
} = contractInfoApi;
